import { render, staticRenderFns } from "./WishListItem.vue?vue&type=template&id=adce5d40&"
import script from "./WishListItem.vue?vue&type=script&lang=js&"
export * from "./WishListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adce5d40')) {
      api.createRecord('adce5d40', component.options)
    } else {
      api.reload('adce5d40', component.options)
    }
    module.hot.accept("./WishListItem.vue?vue&type=template&id=adce5d40&", function () {
      api.rerender('adce5d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/wishList/WishListItem.vue"
export default component.exports